import { Box, Typography } from "@mui/material";
import { NotificationFullData } from "../../layout/UserNotification";
import React from "react";
import useThemeStore from "../../services/store/useThemeStore";
import { wrapperStyles } from "./BookingStarted";
import { contentStyles } from "./BookingStarted";
import { titleStyles } from "./BookingStarted";
import { DateNTime } from "../../utils/dateTime";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCurrentTalentProfile } from "../../hooks";
import { NotificationType } from "../../constants/appConstants";

const FlashCardRefundNotification = ({
  notification,
}: {
  notification: NotificationFullData;
}) => {
  const { darkMode } = useThemeStore();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleClick = () => {
    navigate(`/flash-bookings`);
  };

  const { currentProfile } = useCurrentTalentProfile();

  console.log(notification, "notification_refund");
  return (
    <>
      {!currentProfile?.id &&
        notification.notification_type ===
          NotificationType.FlashCardBookingRefund && (
          <Box
            onClick={handleClick}
            sx={{ ...wrapperStyles(darkMode), cursor: "pointer" }}
          >
            <Box sx={{ ...contentStyles, cursor: "pointer" }}>
              <Typography sx={titleStyles(darkMode)}>
                {t("flash_card_booking_refund.title", { ns: "notification" })}
              </Typography>
              <Typography
                sx={{
                  color: darkMode ? "#e5e7eb" : "#374151",
                  font: "var(--body-xs)",
                  fontWeight: 400,
                }}
              >
                {t("flash_card_booking_refund.message", {
                  ns: "notification",
                  title: notification?.data?.title,
                  price: notification?.data?.price,
                })}
              </Typography>
              {notification?.created_at && (
                <Typography
                  sx={{
                    font: "var(--semibold-xxs)",
                    color: darkMode ? "#9ca3af" : "#64748b",
                    fontWeight: 500,
                  }}
                >
                  {DateNTime.formatRelative(notification.created_at)}
                </Typography>
              )}
            </Box>
          </Box>
        )}

      {currentProfile?.id &&
        notification.notification_type ===
          NotificationType.FlashCardBookingRefund && (
          <Box
            onClick={handleClick}
            sx={{ ...wrapperStyles(darkMode), cursor: "pointer" }}
          >
            <Box sx={{ ...contentStyles, cursor: "pointer" }}>
              <Typography sx={titleStyles(darkMode)}>
                {t("flash_card_cancelled.title", { ns: "notification" })}
              </Typography>
              <Typography
                sx={{
                  color: darkMode
                    ? "var(--neutralWhite)"
                    : "var(--neutralBlack)",
                  font: "var(--body-xs)",
                  fontWeight: 400,
                }}
              >
                {t("flash_card_cancelled.message", {
                  ns: "notification",
                  title: notification?.data?.title,
                  price: notification?.data?.price,
                })}
              </Typography>
              {notification?.created_at && (
                <Typography
                  sx={{
                    font: "var(--semibold-xxs)",
                    color: darkMode ? "#9ca3af" : "#64748b",
                    fontWeight: 500,
                  }}
                >
                  {DateNTime.formatRelative(notification.created_at)}
                </Typography>
              )}
            </Box>
          </Box>
        )}
    </>
  );
};

export default FlashCardRefundNotification;
